import { render, staticRenderFns } from "./CargosSalarios.vue?vue&type=template&id=018bf6c6&scoped=true"
import script from "./CargosSalarios.vue?vue&type=script&lang=js"
export * from "./CargosSalarios.vue?vue&type=script&lang=js"
import style0 from "./CargosSalarios.vue?vue&type=style&index=0&id=018bf6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018bf6c6",
  null
  
)

export default component.exports